<template>
  <div
    class="notification"
    :class="{
      unread: isAdvisor ? notification.countUnread : notification.unread,
      read: isAdvisor ? !notification.countUnread : !notification.unread,
      advisor: isAdvisor,
      expandNotification: isAdvisor && !expanded,
    }"
    @click="expandNotification"
  >
    <div v-if="!isAdvisor" class="notification__content">
      <div class="notification__avatar">
        <profile-preview-image
          :profileId="notification.parameters.entityProfileId"
        />
      </div>
      <div class="notification__desc">
        <span v-html="notification.message"></span>
        <rating-stars
          :max="5"
          v-if="notification.parameters.rating"
          :rating="notification.parameters.rating"
          class="notification__rating"
        />
        <a @click="navigate(notification.id)">{{ notification.linkMessage }}</a>

        <small>
          <timeago
            :datetime="notification.createdDate"
            :auto-update="60"
          ></timeago>
        </small>
      </div>
      <v-btn
        icon
        text
        small
        elevation="0"
        class="notification__mark"
        @click.prevent.stop="
          markNotification(notification.id, !notification.unread)
        "
      >
        <v-icon>bhi-double-check</v-icon>
      </v-btn>
      <notifications-more-menu
        :id="notification.id"
        :unread="!notification.unread"
        :tomorrow="tomorrow"
        :nextWeek="nextWeek"
        :afterTenDays="afterTenDays"
        v-on="$listeners"
        @markAsRead="markNotification(notification.id, !notification.unread)"
        @remindMeTomorrow="markNotification(notification.id, false, tomorrow)"
        @remindMeNextWeek="markNotification(notification.id, false, nextWeek)"
        @remindMeAfterTenDays="
          markNotification(notification.id, false, afterTenDays)
        "
        @toggleShowDatePickerHandler="openSelectDateDialog"
      />
      <select-date-dialog
        :date="date"
        :show-dialog="showSelectDateDialog"
        @close-dialog="closeSelectDateDialog"
        @dismis-dialog="showSelectDateDialog = false"
      />
    </div>
    <div v-else class="notification__content">
      <div class="notification__content--userProfile">
        <div class="notification__avatar">
          <profile-preview-image
            :profileId="
              notificationByPariticpant.notification.parameters.entityProfileId
            "
          />
        </div>
        <div class="notification__desc">
          <span> {{ notificationByPariticpant.profile.fullName }}</span>
          <small>
            {{
              notificationByPariticpant.countUnread > 1
                ? `${notificationByPariticpant.countUnread} unread notifications`
                : notificationByPariticpant.countUnread === 1
                ? '1 unread notification'
                : '0 unread notifications'
            }}
          </small>
        </div>
      </div>
      <v-expand-transition class="notification__expand">
        <div v-show="expanded" class="notification__expand--full">
          <div class="notification__content--groupWrapper">
            <div
              class="notification__content--groupItem"
              v-for="notificationGroup in notificationByPariticpant.notifications"
              :key="notificationGroup.id"
            >
              <div
                class="notification__content notification__content--group"
                :class="notificationGroup.unread ? 'unread' : 'read'"
              >
                <div class="notification__avatar" />
                <div class="notification__desc">
                  <span v-html="notificationGroup.message"></span><br />
                  <rating-stars
                    :max="5"
                    v-if="notificationGroup.parameters.rating"
                    :rating="notificationGroup.parameters.rating"
                    class="notification__rating"
                  />
                  <a @click.prevent.stop="navigate(notificationGroup.id)">{{
                    notificationGroup.linkMessage
                  }}</a
                  ><br />
                  <small>
                    <timeago
                      :datetime="notificationGroup.createdDate"
                      :auto-update="60"
                    ></timeago>
                  </small>
                </div>
              </div>
              <div class="notification__actions">
                <v-btn
                  text
                  elevation="0"
                  class="v-tabs__markAsRead"
                  @click.prevent.stop="
                    markNotification(
                      notificationGroup.id,
                      !notificationGroup.unread,
                    )
                  "
                  >{{
                    notificationGroup.unread ? 'Mark as read' : 'Mark as unread'
                  }}</v-btn
                >
                <notifications-group-more-menu
                  v-if="expanded"
                  :id="notificationGroup.id"
                  :unread="!notificationGroup.unread"
                  :tomorrow="tomorrow"
                  :nextWeek="nextWeek"
                  :afterTenDays="afterTenDays"
                  v-on="$listeners"
                  @markAsRead="
                    markNotification(
                      notificationGroup.id,
                      !notificationGroup.unread,
                    )
                  "
                  @remindMeTomorrow="
                    markNotification(notificationGroup.id, false, tomorrow)
                  "
                  @remindMeNextWeek="
                    markNotification(notificationGroup.id, false, nextWeek)
                  "
                  @remindMeAfterTenDays="
                    markNotification(notificationGroup.id, false, afterTenDays)
                  "
                  @toggleShowDatePickerHandler="
                    openSelectDateDialog(notificationGroup.id)
                  "
                />
              </div>
            </div>
            <select-date-dialog
              :date="date"
              :show-dialog="showSelectDateDialog"
              @close-dialog="closeSelectDateDialog"
              @dismis-dialog="showSelectDateDialog = false"
            />
          </div>
          <v-btn
            v-if="
              notificationByPariticpant.notifications.length > 1 &&
                notificationByPariticpant.notifications.length !==
                  notificationByPariticpant.count
            "
            text
            elevation="0"
            class="v-tabs__showLess"
            @click.prevent.stop="handleMoreNotifications"
            >Load more</v-btn
          >
          <v-btn
            v-if="notificationByPariticpant.countUnread"
            text
            elevation="0"
            class="v-tabs__markAsRead"
            @click.prevent.stop="
              markNotificationGroupedAll(
                notificationByPariticpant.notification.parameters
                  .entityProfileId,
              )
            "
            >Mark group as read</v-btn
          >
          <v-btn
            text
            elevation="0"
            class="v-tabs__showLess"
            @click="expanded = true"
            >Show less</v-btn
          >
        </div>
      </v-expand-transition>
    </div>
  </div>
</template>

<script>
/**
 * @todo: Check navigate between notifications, if we should use entityProfileId or userId from parameters
 */
import { mapState, mapActions, mapGetters } from 'vuex'
import NotificationsGroupMoreMenu from '@/components/notifications/NotificationsGroupMoreMenu.vue'
import NotificationsMoreMenu from '@/components/notifications/NotificationsMoreMenu.vue'
import SelectDateDialog from '@/components/dialogs/SelectDateDialog.vue'
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
import RatingStars from '@/components/exercises/RatingStars.vue'

export default {
  name: 'Notification',
  components: {
    NotificationsGroupMoreMenu,
    NotificationsMoreMenu,
    SelectDateDialog,
    ProfilePreviewImage,
    RatingStars,
  },
  props: {
    notification: {
      type: Object,
      default: function() {
        return {}
      },
    },
    expand: {
      type: Boolean,
    },
    tab: {
      type: Number,
    },
  },
  data() {
    return {
      date: '',
      showSelectDateDialog: false,
      showSelectDateDialogGroup: false,
      dialog: false,
      tomorrow: this.$moment()
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      nextWeek: this.$moment()
        .add(7, 'days')
        .format('YYYY-MM-DD'),
      afterTenDays: this.$moment()
        .add(10, 'days')
        .format('YYYY-MM-DD'),
      isLoading: false,
      expanded: false,
      notificationsGroup: {},
      notifyId: null,
    }
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    ...mapState('dictionariesStates', ['dictionaryPracticeUserRole']),
    ...mapGetters('userStates', ['getRolename']),
    isAdvisor() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Advisor
      )
    },
    notificationByPariticpant() {
      return this.notification
    },
  },
  methods: {
    ...mapActions('userStates', [
      'readNotification',
      'readNotificationGrouped',
      'getNotificationsGroupedByParticipantId',
    ]),
    markNotification(id, unread, resendAt) {
      if (this.isAdvisor) {
        this.readNotification({
          id: id,
          unread: unread,
          resendAt,
          isAdvisor: this.isAdvisor,
          tab: this.tab,
          participantId: this.notificationByPariticpant.notification.parameters
            .entityProfileId,
        })
      } else {
        this.readNotification({
          id: id,
          unread: unread,
          resendAt,
        })
      }
    },
    async markNotificationGroupedAll(id) {
      await this.readNotificationGrouped({
        id,
        tab: this.tab,
        participantId: this.notificationByPariticpant.notification.parameters
          .entityProfileId,
      })
    },
    async handleMoreNotifications() {
      const pageSize = 5
      const pageLastItem = this.notificationByPariticpant.notifications[
        this.notificationByPariticpant.notifications.length - 1
      ].id

      await this.getNotificationsGroupedByParticipantId({
        id: this.notificationByPariticpant.notification.parameters
          .entityProfileId,
        tab: this.tab,
        pageSize,
        pageLastItem,
      })
    },
    async expandNotification() {
      this.expanded = !this.expanded
      if (this.expanded && this.isAdvisor) {
        await this.getNotificationsGroupedByParticipantId({
          id: this.notificationByPariticpant.notification.parameters
            .entityProfileId,
          tab: this.tab,
        })
      }
    },
    async navigate(notificationGroupId) {
      let route = false
      const notificationByParticipant =
        this.isAdvisor &&
        this.notificationByPariticpant.notifications.find(
          notification => notification.id === notificationGroupId,
        )
      const notification = this.isAdvisor
        ? notificationByParticipant
        : this.notification
      if (notification?.type && notification?.parameters) {
        switch (notification.type) {
          case 'ACTIVITIES':
            route = {
              name: 'Patient Activities Report',
              path: '/participants/:id/routines-progress',
              query: { date: notification.parameters?.activityDate },
              params: {
                id: this.getProfilePreview(
                  notification?.parameters?.entityProfileId,
                )?.userId,
              },
            }
            break
          case 'JOURNAL':
            route = {
              name: 'Patient Journal',
              path: '/participants/:id/journal',
              query: { date: notification?.parameters?.journalDate },
              params: {
                id: this.getProfilePreview(
                  notification?.parameters?.entityProfileId,
                )?.userId,
              },
            }
            break
          case 'INACTIVE_USER':
            switch (notification?.code) {
              case 'INACTIVE_PARTICIPANT':
                route = {
                  name: 'Patient',
                  path: '/participants/:id',
                  params: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                  },
                }
                break
              default:
            }
            break
          case 'NEW_LOGIN':
            switch (notification?.code) {
              case 'NEW_LOGIN_PARTICIPANT':
                route = {
                  name: 'Patient',
                  path: '/participants/:id',
                  params: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                  },
                }
                break
              case 'NEW_LOGIN_ADVISOR':
                route = {
                  name: 'Practice Staff',
                  path: '/company/:id/staff',
                  query: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                    n: 1,
                  },
                  params: { id: notification?.parameters?.companyId },
                }
                break
              case 'NEW_LOGIN_COMPANY_ADMIN':
                route = {
                  name: 'Practice Staff',
                  path: '/company/:id/staff',
                  query: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                    n: 1,
                  },
                  params: { id: notification?.parameters?.companyId },
                }
                break
              case 'NEW_LOGIN_TEAM':
                route = {
                  name: 'Practice Staff',
                  path: '/company/:id/staff',
                  query: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                    n: 1,
                  },
                  params: { id: notification?.parameters?.companyId },
                }
                break
              case 'NEW_LOGIN_CONSULTANT':
                route = {
                  name: 'BH User General',
                  path: '/bhusers/:id/general',
                  params: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                  },
                }
                break
            }
            break
          case 'ROUTINE':
            route = {
              name: 'Patient Exercises Report',
              path: '/participants/:id/routines-progress',
              /******** commented because https://itsorce.atlassian.net/browse/MVP4BH-3367 /********/
              // query: {
              //   date: notification.parameters?.routineDate,
              //   expandDay: notification.parameters?.expandDay,
              //   activityId: notification.parameters?.activityId,
              // },
              params: {
                id: this.getProfilePreview(
                  notification?.parameters?.entityProfileId,
                )?.userId,
              },
            }
            switch (notification?.code) {
              case 'ROUTINE_SHARED_FOLDER':
                route = {
                  name: 'Exercises',
                  path: '/activities',
                  params: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                  },
                }
                break
              default:
            }
            break
          case 'SMART_SURVEY':
            route = {
              name: 'Patient Smart Survey',
              path: '/participants/:id/smart-survey',
              params: {
                id: this.getProfilePreview(
                  notification?.parameters?.entityProfileId,
                )?.userId,
              },
            }
            break
          case 'SWAP':
            route = {
              name: 'Participant Swaps',
              path: '/participants/:id/swaps',
              query: { id: notification?.parameters?.swapId },
              params: {
                id: this.getProfilePreview(
                  notification?.parameters?.entityProfileId,
                )?.userId,
              },
            }
            break
          case 'MEDIA_LIBRARY':
            switch (notification?.code) {
              case 'MEDIA_LIBRARY_SHARED_MEDIA':
                route = {
                  name: 'Library',
                  path: '/library',
                  params: {
                    id: this.getProfilePreview(
                      notification?.parameters?.entityProfileId,
                    )?.userId,
                    folderId: notification.parameters?.mediaLibraryFolderId,
                  },
                }
                break
              default:
            }
            break
          default:
            break
        }
        if (route) this.$router.push(route)
        this.readNotification({
          id: notification.id,
          isAdvisor: this.isAdvisor,
          participantId: notification?.parameters?.entityProfileId,
        })
        this.$emit('close-dialog')
      }
    },
    openSelectDateDialog(notificationGroupId) {
      this.showSelectDateDialog = true
      if (notificationGroupId && this.isAdvisor) {
        this.notifyId = notificationGroupId
      }
    },
    closeSelectDateDialog(selectedDate) {
      const notificationId = !this.isAdvisor
        ? this.notification.id
        : this.notifyId
      this.showSelectDateDialog = false
      if (this.isAdvisor) {
        this.readNotification({
          id: notificationId,
          unread: false,
          resendAt: selectedDate,
          isAdvisor: this.isAdvisor,
          participantId: this.notificationByPariticpant.profile.profileId,
        })
      } else {
        this.readNotification({
          id: notificationId,
          unread: false,
          resendAt: selectedDate,
        })
      }
    },
    getProfilePreview(profileId) {
      if (this.profilePreviews.length && Array.isArray(this.profilePreviews))
        return this.profilePreviews.find(el => {
          if (el.profileId === profileId) {
            return el
          }
        })
      else return null
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.notification {
  display: flex;
  align-items: center;
  margin: 16px 0;
  position: relative;
  width: 100%;
  &:not(.advisor) {
    padding: 16px;
  }
  &__rating {
    padding: 8px 0;
  }
  &__actions {
    display: flex;
    justify-content: space-around;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding: 8px 16px;

    .v-tabs__markAsRead {
      width: auto;
      border: none;
      padding: 0 !important;
      &:hover {
        &::before {
          opacity: 0;
        }
      }
    }
  }
  &__expand {
    width: 100%;
    &--full {
      width: 100%;
    }
  }
  &.advisor {
    flex-direction: column;
    cursor: pointer;
    background-color: $bh-white;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px 0px,
      rgba(0, 0, 0, 0.08) 0px 0px 1px 0px;
    .v-tabs__markAsRead {
      margin-top: 10px;
      &:hover {
        color: $bh-blue !important;
      }
    }
    .v-tabs__showLess {
      margin-top: 10px;
      font-weight: 700;
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      width: 100%;
      color: rgba(0, 0, 0, 0.4);
      transition: background-color 0.2s ease-in-out;
      &:hover {
        background-color: $bh-gray--5;
      }
    }
    .notification__content {
      display: block;

      &--group {
        display: flex;
        padding: 0;
      }

      &--groupItem {
        padding: 16px;
      }
    }
    .notification__desc {
      span {
        font-size: 12px;
        line-height: 20px;
        color: $bh-black;
        font-weight: 700;
      }
      small {
        font-size: 12px;
        line-height: 20px;
        color: $bh-gray--1;
      }
    }
  }
  &.expandNotification {
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 11px;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      background-color: $bh-white;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 1px 0px;
    }

    &::before {
      top: 100%;
      width: calc(100% - 22px);
      z-index: -1;
      opacity: 0.8;
    }
    &::after {
      top: calc(100% + 11px);
      width: calc(100% - 44px);
      z-index: -2;
      opacity: 0.6;
    }
    .notification__content {
      align-items: center;
    }
  }
  &.read {
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: none;
    &.expandNotification {
      &::before,
      &::after {
        opacity: 0.8;
        background-color: transparent;
        border: 1px solid rgba(0, 0, 0, 0.08);
      }
    }
    .notification__mark {
      color: $bh-blue;
      opacity: 1;
    }
    .notification__content:not(.notification__content--group) {
      opacity: 0.4;
    }
    .v-tabs__markAsRead {
      color: rgba(0, 0, 0, 0.4) !important;
    }
  }
  .notification__content--group {
    &.read {
      opacity: 0.4;
      ~ .v-tabs__markAsRead {
        color: rgba(0, 0, 0, 0.4) !important;
      }
    }
  }
  &.unread {
    .notification__avatar {
      overflow: visible;
      .v-avatar {
        border-radius: 8px !important;
      }
      &::after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: block;
        background-color: $bh-blue--2;
        border: 2px solid $bh-white;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -4px;
        z-index: 1;
      }
    }
    .notification__content--group {
      .notification__avatar {
        &::after {
          content: none;
        }
      }
    }
  }
  &:hover {
    .notification__mark {
      opacity: 1;
    }
  }
  &__avatar {
    width: 48px;
    height: 48px;
    overflow: hidden;
    flex-shrink: 0;
    margin-right: 16px;
    border-radius: 8px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__desc {
    line-height: 1.5;
    font-size: 0.9rem;
    flex-grow: 1;
    a {
      text-decoration: none;
      color: $bh-blue !important;
      font-weight: bold;
      display: block;
    }
    small {
      display: block;
      line-height: 1;
      color: $bh-gray;
    }
  }
  &__mark {
    opacity: 0;
    .v-icon {
      opacity: 1;
    }
  }
  &__content {
    display: flex;
    width: 100%;

    &--groupWrapper {
      margin-top: 6px;
    }

    &--group {
      padding: 6px 0;
    }

    &--userProfile {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding: 16px;
    }
  }
}
</style>
